import {
	Component,
	EventEmitter,
	Input,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "./common-imports"
import { StoreService } from "./services/store.service"
import { ModalService } from "./services/modal.service"
import { IsByTypes } from "./definitions/types"
import { ApiService } from "./services/api.service"
import { ModalWrapComponent } from "./modal-wrap/modal-wrap.component"
import { ConfirmComponent } from "./confirm/confirm.component"
import { LangValPipe } from "./utils/lang-val.pipe"
import { GenTableDisplayComponent } from "./gen-table-display/gen-table-display.component"

@Component({
	selector: "app-send-proforma",
	imports: [
		COMMON_IMPORTS,
		ModalWrapComponent,
		ConfirmComponent,
		LangValPipe,
		GenTableDisplayComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		@switch (modalProps?.name) {
			@case ("confirm") {
				<app-modal-wrap
					(onClose)="modalProps = null; onDone.emit()"
					title="confirm_sending"
					modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
				>
					<app-confirm
						(onClose)="
							modalProps = null; $event ? handleConfirm() : onDone.emit()
						"
						[freeText]="modalProps.freeText | langVal"
					/>
				</app-modal-wrap>
			}
			@case ("table-display-contactways") {
				<app-modal-wrap
					(onClose)="modalProps = null; onDone.emit()"
					title="contactways"
					modalWrapperClass="modal-800"
				>
					<app-gen-table-display
						(onClose)="
							modalProps = null;
							$event?.length ? handleContactwaysClose($event) : onDone.emit()
						"
						tableName="contactways"
						filterField="patient_id"
						[filterFieldValue]="patient.id"
						fieldNameInItemToDisplay="contactway"
						isCheckItems
						[filterFieldApiObject]="{ contactway_identifier: 'email' }"
					/>
				</app-modal-wrap>
			}
		}
	`,
})
export class SendProformaComponent {
	modalProps: any = null
	@Input() patient: any | null = null
	@Input() isBy: IsByTypes = null
	@Output() onDone = new EventEmitter()

	constructor(
		private store: StoreService,
		private modalService: ModalService,
		private apiService: ApiService
	) {}

	async ngOnInit() {
		let phone = this.store.getPhoneContactway(this.patient, this.isBy)
		if (!phone && (this.isBy == "whatsapp" || this.isBy == "sms")) {
			this.modalService.openToast("no_valid_phone")
			this.onDone.emit()
			return
		}

		const res = await this.apiService.post("pre_send_proforma_text", {
			patient_id: this.patient.id,
			isBy: this.isBy,
		})

		const message_text = res.message_text

		if (!message_text) {
			this.modalService.openToast("no_followups_or_debt")
			this.onDone.emit()
			return
		}

		if (this.isBy == "whatsapp") {
			const waphone = phone?.contactway.substring(1)
			this.store.isMobile = window.innerWidth < 992
			const isApi =
				this.store.isMobile || this.store.cc()?.wa_app_installed == "yes"
			const whatsappUrl = `https://${isApi ? "api" : "web"}.whatsapp.com/send/?phone=972${waphone} &text=${message_text}"&app_absent=1"`
			window.open(whatsappUrl, "_blank")
			this.onDone.emit()
			return
		}

		this.modalProps = {
			name: "confirm",
			freeText: message_text.replace(/\r/g, "<br />"),
		}
	}
	handleConfirm() {
		if (this.isBy !== "email") {
			this.handleContactwaysClose()
			return
		}
		this.modalProps = { name: "table-display-contactways" }
	}
	async handleContactwaysClose(arr: any[] | null = null) {
		const sendRes: any = await this.apiService.post("send_proforma_text", {
			patient_id: this.patient.id,
			emailsList: arr,
		})
		this.modalService.openToast(
			sendRes?.success ? "sent_successfully" : "send_failed"
		)
		this.onDone.emit()
	}
}
